// extracted by mini-css-extract-plugin
export var header = "_s5-1";
export var maskBottom = "_s5-6";
export var maskMiddle = "_s5-7";
export var maskTop = "_s5-5";
export var root = "_s5-0";
export var scrollDownButton = "_s5-3";
export var scrollDownButtonHidden = "_s5-4";
export var viewport = "_s5-2";